module.exports = __webpack_public_path__ + "static/media/Iconly-Light-Delete-Red.ab198a86.svg";